// SfNavLink.js
import React from "react"
import PropTypes from "prop-types"
import { NavLink } from 'react-router-dom';
import { ADMIN_ONLY_TAB, REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";
import useFeatureFlags from "hooks/useFeatureFlags";
import AdminOnlyIcon from "./AdminOnlyIcon";
import { isBenepathBrand } from "config";

const SfNavLink = ({ position, tabName, customActiveTab, setcustomActiveTab, isAdmin, isURL, url, targetID, id }) => {
  const [isFeatureFlagActive] = useFeatureFlags();

  const isActive = customActiveTab ? customActiveTab === position : false;
  const activeColor = isBenepathBrand ? '#E67917' : '#2f9ee9';
  const style = isFeatureFlagActive(REQUIRED_FEATURE_FLAGS?.SF_FEATURE_FLAG_SHOW_NEW_TAB_DESIGN) ? (isActive ? { backgroundColor: activeColor, color: '#fff' } : {}) : (isActive ? { boxShadow: 'inset 0 -2px 0 #2f9ee9', fontWeight: '600' } : {});

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  return (
    <>
    {isFeatureFlagActive(REQUIRED_FEATURE_FLAGS?.SF_FEATURE_FLAG_SHOW_NEW_TAB_DESIGN) ? (
      isURL ? 
        <NavLink
          className="nav-link sfactiveNew me-2 d-flex align-items-center"
          id={id}
          to={url}
          style={style}
          activeClassName='sfnavactiveNew'
        >
          {tabName}
          {isAdmin && <AdminOnlyIcon idFor={targetID} tooltipText={ADMIN_ONLY_TAB} />}
        </NavLink>
      :
        <NavLink
          className="nav-link sfactiveNew me-2 d-flex align-items-center"
          id={id}
          to={location}
          style={style}
          onClick={() => toggleCustom(position)}
          activeClassName={isActive && 'sfnavactiveNew'}
        >
          {tabName}
          {isAdmin && <AdminOnlyIcon idFor={targetID} tooltipText={ADMIN_ONLY_TAB} />}
        </NavLink>
      )
    :
      (
        isURL ? 
          <NavLink
            className={`nav-link text-black sfnavlink sfactive ${position === '1' ? 'me-3' : 'mx-3'}  d-flex align-items-center`}
            id={id}
            to={url}
            style={style}
            activeClassName='sfnavactive'
          >
            {tabName}
            {isAdmin && <AdminOnlyIcon idFor={targetID} tooltipText={ADMIN_ONLY_TAB} />}
          </NavLink>
        :
          <NavLink
            className={`nav-link text-black sfnavlink sfactive ${position === '1' ? 'me-3' : 'mx-3'} pb-0`}
            id={id}
            to={location}
            style={style}
            onClick={() => toggleCustom(position)}
          >
            {tabName}
            {isAdmin && <AdminOnlyIcon idFor={targetID} tooltipText={ADMIN_ONLY_TAB} />}
          </NavLink>
      )
    }
    </>
  )
}

SfNavLink.propTypes = {
  position: PropTypes.string,
  tabName: PropTypes.string,
  location: PropTypes.string,
  url: PropTypes.url,
  customActiveTab: PropTypes.string,
  setcustomActiveTab: PropTypes.func,
  isAdmin: PropTypes.bool,
  targetID: PropTypes.string,
  isURL: PropTypes.bool,
}

export default SfNavLink